import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AvatarsContext = /*#__PURE__*/createContext(null);
export function AvatarsProvider({
  data,
  children
}) {
  const contextValue = useMemo(() => ({
    avatarData: data
  }), [data]);
  return /*#__PURE__*/_jsx(AvatarsContext.Provider, {
    value: contextValue,
    children: children
  });
}
export function useAvatarData() {
  const ctx = useContext(AvatarsContext);
  if (!ctx) {
    throw new Error('useAvatarData must be used within an AvatarsProvider');
  }
  return ctx.avatarData;
}

/**
 * Hook to access company avatar url from avatar data
 * @returns avatar url provided companyId.
 * If no companyId, defaults  to first company result.
 */
export function useCompanyAvatarUrl(companyId) {
  var _companies$;
  const data = useAvatarData();
  if (!data) return undefined;
  const companies = data.results.filter(r => r.type === 'COMPANY');
  if (companyId) {
    var _companies$find;
    return (_companies$find = companies.find(r => r.id === companyId)) === null || _companies$find === void 0 ? void 0 : _companies$find.avatarUrl;
  }
  return (_companies$ = companies[0]) === null || _companies$ === void 0 ? void 0 : _companies$.avatarUrl;
}